import { baseApi } from 'api/baseApi.ts';
import { useCreateAccountMutation, useLazyAuthenticateQuery, useRegisterMutation, useTrialMutation } from 'api/loginApi.ts';
import axios from 'axios';
import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RegisterModalComponent from "ui/components/RegisterModal";
import { isInIframe } from 'utils/proxyUtils.ts';
import { getEmailInfo } from '../../../../../utils/use-email-domain.ts';
import { bootstrapAction } from '../../../store/bootstrapSlice.ts';
import { getSelectedSiteCollaborateInfo, getSelectedSiteId } from '../../../store/siteInfoSlice.ts';
import { setHelpModalOpen } from '../../../store/uiSlice.ts';
import { getShowCompanyDetail, getSignUpOption, getUser, setShowCompanyDetail, setShowForgotPassword, setShowLogin, setShowRegister, setSignupOption, setToken } from '../../../store/userSlice.ts';

export const RegisterModal = () => {
  const [companyName, setCompanyName] = useState("")
  const [authenticate] = useLazyAuthenticateQuery()
  const dispatch = useDispatch()
  const userData = useSelector(getUser);
  const signupOption = useSelector(getSignUpOption)
  const collaborateInfo = useSelector(getSelectedSiteCollaborateInfo)
  const [register, { error: createError, isLoading: createLoading, isSuccess: createSuccess }] = useRegisterMutation()
  const [createUser, { error: createAccountError, isLoading: createAccountLoading, isSuccess: createAccountSuccess }] = useCreateAccountMutation()
  const [trial, { error: trialError, isLoading: trialLoading, isSuccess: trialSuccess }] = useTrialMutation()
  const [agreeToPrivacy, setAgreeToPrivacy] = useState(false)
  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  // const [signupOption, setSignupOption] = useState("")
  const [source, setSource] = useState("")
  const [teamSize, setTeamSize] = useState("")
  const [isRegisterPending, setIsRegisterPending] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const siteId = useSelector(getSelectedSiteId)
  const siteInfo = useSelector(getSelectedSiteCollaborateInfo)
  const showCompanyDetail = useSelector(getShowCompanyDetail)

  type QueryError = {
    data?: {
      message: string
      errors: Record<string, string[]>
    }
  }
  const marketingSiteSite = new URL(window.location.toString()).searchParams.get(
    'new'
  )

  const activationCallback = new URL(window.location.toString()).searchParams.get('activation_callback');

  const handleChangeCompanyName = (e: ChangeEvent<HTMLInputElement>) => {
    setCompanyName(e.target.value)
  }

  const handleChangeEmail = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }

  const handleChangeName = (e: ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value)
  }

  const handleChangePrivacy = (e: boolean) => {
    setAgreeToPrivacy(e)
  }

  const handleChangeSignupOption = (option: string) => {
    dispatch(setSignupOption(option))
  }

  const handleGotoLogin = async () => {
    // open small window to handle auth passback center of screen

    if (!isInIframe()) {
      const left = (screen.width - 400) / 2;
      const top = (screen.height - 520) / 2;

      const authWindow = window.open('https://localhost:3000', 'Atarim Login',
        'resizable=yes, width=400, height=580, top='
        + top + ', left=' + left);

      if (authWindow) {
        const { data } = await axios.get('https://public.test/wp/auth');
        const { read_key, write_key } = data;

        authWindow.location.href = `https://localhost:3000/?from_script=true&write_key=${write_key}`
        authWindow.focus()
        const interval = setInterval(async () => {
          const { data } = await axios.get('https://public.test/wp/pollForAccessToken?read_key=' + read_key)
          if (data.access_token) {
            authWindow.close()
            clearInterval(interval)
            await authenticate({ token: data.access_token }).unwrap().then(
              () => {
                dispatch(setShowLogin(false))
                dispatch(setShowForgotPassword(false))
                dispatch(setShowRegister(false))
                dispatch(baseApi.util.resetApiState())
                dispatch(bootstrapAction())
              }
            )

          }
        }, 500)
        return;
      }
    }


    dispatch(setShowLogin(true))
    dispatch(setShowForgotPassword(false))
    dispatch(setShowRegister(false))
  }

  const handleRegister = () => {

    const currentEmailPrefix = email.split('@')[0];

    // 1. For marketing site users with no name, use email prefix
    // 2. Otherwise use their entered name
    const nameToUse = marketingSiteSite || (!name || name.trim() === '')
      ? currentEmailPrefix
      : name;

    if (activationCallback && !siteId) {
      createUser({
        email,
        name: nameToUse,
        password: "sendSetPasswordEmail@1",
      })
      return
    }

    if (isInIframe()) {
      setIsRegisterPending(true)
      window.parent.postMessage({
        type: 'REGISTER',
        registerData: {

          build_websites: false,
          email,
          guest_user_id: null,
          name: nameToUse,
          password: "sendSetPasswordEmail",
          siteId: siteId ?? "",
          site_id: siteId ?? "",
          ...(!marketingSiteSite && { role: 'collaborator' })
        }
      }, '*')
      return
    }
    register({
      build_websites: false,
      email,
      guest_user_id: null,
      name: nameToUse,
      password: "sendSetPasswordEmail",
      siteId: siteId ?? "",
      site_id: siteId ?? "",
      ...(!marketingSiteSite && { role: 'collaborator' })
    })
  }

  const handleSetSource = (e: string) => {
    setSource(e)
  }

  const handleSetTeamSize = (e: string) => {
    setTeamSize(e)
  }

  const handleTrial = () => {
    trial({ company_name: companyName, source, team_size: teamSize })
  }

  useEffect(() => {
    if (!isInIframe()) return;

    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'REGISTER_RESPONSE') {
        if (event.data.token) {
          dispatch(setToken(event.data.token));
          setIsRegisterPending(false);
          setIsSuccess(true);
          dispatch(bootstrapAction());
          dispatch(setShowForgotPassword(false))
          dispatch(setShowLogin(false))
          dispatch(setShowRegister(false))
          if (!marketingSiteSite) {
            dispatch(setHelpModalOpen(true))

          }

        }
      } else if (event.data.type === 'REGISTER_FAILED') {
        setIsRegisterPending(false);
        setIsSuccess(false);
        console.error('Register error:', event?.data?.error);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [dispatch]);


  useEffect(() => {
    if ((trialError || trialSuccess)) {
      dispatch(setShowForgotPassword(false))
      dispatch(setShowLogin(false))
      dispatch(setShowRegister(false))
      dispatch(setShowCompanyDetail({ open: false, companyName: companyName }));
      dispatch(bootstrapAction())
      dispatch(setSignupOption(''))
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trialError, trialSuccess]);

  useEffect(() => {
    if (collaborateInfo?.result?.hide_atarim) {
      dispatch(setSignupOption('on_off'));
      return
    }
    if (marketingSiteSite && !collaborateInfo?.result?.hide_atarim) {
      dispatch(setSignupOption('regular'))
    }
  }, [dispatch, marketingSiteSite, signupOption, collaborateInfo?.result])

  useEffect(() => {

    if (userData && userData?.isGuest) {
      setSignupOption('regular')
    }
  }, [userData])

  const { isGeneric, topLevelDomain } = getEmailInfo(userData?.email || email);

  useEffect(() => {
    if (!isGeneric) {
      setCompanyName(topLevelDomain || '')
    }
  }, [userData, topLevelDomain, isGeneric])


  const registrationStepTwo = ((createSuccess || createAccountSuccess || isSuccess) && (!trialSuccess && userData.role === 'admin')) || showCompanyDetail;
  const whitelabelLogoFallback = 'https://wpfeedback-image.s3.us-east-2.amazonaws.com/settings/1629955997_Atarim-no-padding-original.png'

  return <RegisterModalComponent
    agreeToUserPrivacy={agreeToPrivacy}
    collabMode={true}
    comingFromMainSite={marketingSiteSite || activationCallback}
    companyName={companyName}
    createError={(createError && (createError as QueryError).data?.errors) || (createAccountError && (createAccountError as QueryError).data?.errors)}
    email={email}
    imageGraphicItem=""
    isRegisterPending={createLoading || createAccountLoading || isRegisterPending}
    isTrialPending={trialLoading}
    itemDetails={collaborateInfo?.result}
    itemType=""
    handleChangeCompanyName={handleChangeCompanyName}
    handleChangeEmail={handleChangeEmail}
    handleChangeName={handleChangeName}
    handleChangeSignupOption={handleChangeSignupOption}
    handleGoogleRegister={() => { }}
    handleGotoLogin={handleGotoLogin}
    handleStartTrial={handleTrial}
    logoSrc={siteInfo?.result?.setting?.whitelabel.logo || whitelabelLogoFallback}
    name={name}
    projectScreenshot={''}
    projectUrl=""
    registerUser={handleRegister}
    registrationStepTwo={registrationStepTwo || false}
    setAgreeToUserPrivacy={handleChangePrivacy}
    setSource={handleSetSource}
    setTeamSize={handleSetTeamSize}
    SignupOption={signupOption}
    source={source}
    teamSize={teamSize}
    trialError={trialError && (trialError as QueryError).data?.errors}
    userData={undefined}
    container={document.getElementById('root-atarim')?.shadowRoot?.getElementById('app-wrapper')}
    showRightSide={false}

  />
}